package mo.web.portfoliofront.infrastructure.models

data class KeyEvent(
    val date: String,
    val title: String,
    val description: String,
)
